import { getAssignmentTypesUrl } from "../config/Config";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./ServiceHelper";

export class AssignmentTypeService {
  static getAssignmentTypes = () => {
    return getRequest(getAssignmentTypesUrl());
  };

  static createAssignmentType = (assignmentType) => {
    return postRequest(getAssignmentTypesUrl(), assignmentType);
  };

  static getAssignmentTypeById = (assignmentTypeId) => {
    return Promise.resolve(
      getRequest(getAssignmentTypesUrl() + "/" + assignmentTypeId)
    );
  };
  static updateAssignmentType = (assignmentType) => {
    return putRequest(
      getAssignmentTypesUrl() + "/" + assignmentType.id,
      assignmentType
    );
  };

  static deleteAssignmentType = (assignmentTypeId) => {
    return deleteRequest(getAssignmentTypesUrl() + "/" + assignmentTypeId);
  };
}
